import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mwo-language-dialog',
  templateUrl: './language-dialog.component.html',
  styleUrls: ['./language-dialog.component.scss']
})
export class LanguageDialogComponent implements OnInit {

  constructor(public translate: TranslateService,
              private dialogRef: MatDialogRef<LanguageDialogComponent>) { }

  ngOnInit(): void {
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    this.dialogRef.close();
  }

}
